<template>
  <v-card width="100%" elevation="0">
    <v-card-title class="pb-0 pl-1">Products</v-card-title>

    <div class="pl-1">
      <div>
        <div class="d-flex overline" style="align-items: center; gap: 8px;">
          <b class="blue--text">Low product:</b>
          <v-btn
            elevation="0"
            x-small
            color="primary"
            @click="addRow('lowProducts')"
          >
            Add
          </v-btn>
        </div>

        <div class="d-flex" style="flex-direction: column; gap: 6px;">
          <div
            v-for="(entry, index) in lowProducts"
            :key="`low-${index}`"
            class="tl__product tl__product--low d-flex justify-space-between"
            style="gap: 8px; align-items: center"
          >
            <r-product-dropdown :model.sync="entry.product" :clearable="true"/>

            <v-text-field
              v-model.number="entry.amount"
              label="Amount"
              hide-details
              type="number"
              class="col-2 px-0 pb-0"
            />

            <v-icon
              class="mr-2"
              small
              color="red"
              @click.stop="removeRow('lowProducts', index)"
            >
              mdi-delete
            </v-icon>
          </div>
        </div>
      </div>

      <div class="my-4">
        <div class="d-flex overline" style="align-items: center; gap: 8px;">
          <b class="blue--text">Middle product:</b>
          <v-btn
            elevation="0"
            x-small
            color="primary"
            @click="addRow('midProducts')"
          >
            Add
          </v-btn>
        </div>

        <div class="d-flex" style="flex-direction: column; gap: 6px;">
          <div
            v-for="(entry, index) in midProducts"
            :key="`mid-${index}`"
            class="tl__product tl__product--mid d-flex justify-space-between"
            style="gap: 8px; align-items: center"
          >
            <r-product-dropdown :model.sync="entry.product" :clearable="true"/>

            <v-text-field
              v-model.number="entry.amount"
              label="Amount"
              hide-details
              type="number"
              class="col-2 px-0 pb-0"
            />

            <v-icon
              class="mr-2"
              small
              color="red"
              @click.stop="removeRow('midProducts', index)"
            >
              mdi-delete
            </v-icon>
          </div>
        </div>
      </div>

      <div>
        <div class="d-flex overline" style="align-items: center; gap: 8px;">
          <b class="blue--text">High product:</b>
          <v-btn
            elevation="0"
            x-small
            color="primary"
            @click="addRow('highProducts')"
          >
            Add
          </v-btn>
        </div>

        <div class="d-flex" style="flex-direction: column; gap: 6px;">
          <div
            v-for="(entry, index) in highProducts"
            :key="`high-${index}`"
            class="tl__product tl__product--high d-flex justify-space-between"
            style="gap: 8px; align-items: center"
          >
            <r-product-dropdown :model.sync="entry.product" :clearable="true"/>

            <v-text-field
              v-model.number="entry.amount"
              label="Amount"
              hide-details
              type="number"
              class="col-2 px-0 pb-0"
            />

            <v-icon
              class="mr-2"
              small
              color="red"
              @click.stop="removeRow('highProducts', index)"
            >
              mdi-delete
            </v-icon>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {
  ChristmasProducts,
  ChristmasProductEntry,
} from "@/modules/redactor/models/smart-offer/bundle-christmas/ChristmasProducts";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";

export default {
  name: "r-christmas-products",
  components: { RProductDropdown },

  props: {
    model: VueTypes.instanceOf(ChristmasProducts),
  },

  computed: {
    lowProducts: {
      get() {
        return this.model.low || [];
      },
      set(val) {
        this.model.low = val;
        this.emitSync();
      },
    },
    midProducts: {
      get() {
        return this.model.mid || [];
      },
      set(val) {
        this.model.mid = val;
        this.emitSync();
      },
    },
    highProducts: {
      get() {
        return this.model.high || [];
      },
      set(val) {
        this.model.high = val;
        this.emitSync();
      },
    },
  },

  methods: {
    addRow(kind) {
      const items = this[kind].slice();
      items.push(new ChristmasProductEntry(null, 0));
      this[kind] = items;
    },

    removeRow(kind, index) {
      const items = this[kind].slice();
      items.splice(index, 1);
      this[kind] = items;
    },

    emitSync() {
      this.$emit("update:model", this.model);
    },
  },
};
</script>
